<template>
  <b-col lg="12">


    <b-col lg="12">
      <b-row>
        <b-col>
          <h3 class="mt-3 mb-3">برندها</h3>
        </b-col>

        <b-col class="text-left ml-5">
          <b-button pill :to="{name:'TrashBrand'}" class="ml-2 mt-3 mb-3" variant="danger">سطل زباله</b-button>
          <b-button pill :to="{name:'CreateBrand'}" class="ml-2 mt-3 mb-3" variant="purple">افزودن برند</b-button>
          <LanguageSelectBox @changeLanguage="emitToParent" module-name="brand" class="mx-4 d-inline-block"/>
        </b-col>

      </b-row>
    </b-col>

    <b-row>
      <slot></slot>

    </b-row>

  </b-col>
</template>

<script>
import LanguageSelectBox from "../../../components/dashboard/Language/LanguageSelectBox";

export default {
  name: "layout",
  components: {LanguageSelectBox},
  methods: {
    emitToParent() {
      this.$emit('changeLanguage', true)
    }
  }
}
</script>

<style scoped>

</style>